import { ActionsWithPaginationQuery, MinActionsQuery } from 'generated/graphql';
export { ActivityStatus, IncentiveType } from 'generated/graphql';

export type PaymentProcessor = {
  name: string;
  label: string;
};

export enum PayPalPayoutDisbursementCompositeKeyPrefix {
  Donation = 'DO',
  Match = 'MA',
  CoveredFee = 'CF',
}

const COVERED_FEE_PAYOUT_NOTE_DELIMITER = 'Donation fees covered';
const MATCH_PAYOUT_NOTE_DELIMITER = 'Match from';
const CORPORATE_PAYOUT_NOTE_DELIMITER = 'Corporate Donation from';
const PROCESSING_FEE_PAYOUT_NOTE_DELIMITER = 'Processing Fee of';
const GAW_FUNDS_TRANSFER = 'Transfer of funds';

export enum PayoutNoteDelimiters {
  ProcessingFee = PROCESSING_FEE_PAYOUT_NOTE_DELIMITER,
  CoveredFee = COVERED_FEE_PAYOUT_NOTE_DELIMITER,
  Match = MATCH_PAYOUT_NOTE_DELIMITER,
  Corporate = CORPORATE_PAYOUT_NOTE_DELIMITER,
  GAWFundsTransfer = GAW_FUNDS_TRANSFER,
}

/* Types based off the Actions query return */
export type MinAction = MinActionsQuery['actionsWithPagination'];
export type Action = ActionsWithPaginationQuery['actionsWithPagination'];
export type ActionCause = Action['Causes'][0];
export type Activity = Action['Activities'][0];
